import React, { useState, useEffect, useCallback } from "react";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import { mapToPresentable, mapejos } from "../../utils/Mapejos";
import TeclaEscEnter from "../../utils/Teclaescenter";
import { API_URL } from "../../utils/config";
import { formatAddress } from "../../utils/Utilitats";
import {
  aplicarValidacio,
  validarCodiPostal,
  validarDocumentIdentitat,
  validarEmail,
  validarTelefon,
  validarUrl,
} from "../../utils/Validacions";
import AjudaEntitats from "./AjudaEntitats";
import { BotoAjuda } from "./AjudaModal";

function mateixId(a, b) {
  if (a == null || b == null || a === "") return false;
  return Number(a) === Number(b);
}

function etiquetaDePartDe(opt) {
  return String(opt?.NomMostrar || opt?.Nom || opt?.nom || "").trim();
}

async function llegirResposta(response) {
  const text = await response.text();
  const inici = text.indexOf("{");
  const fi = text.lastIndexOf("}");
  if (inici === -1 || fi < inici) {
    const net = text.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    throw new Error(net.slice(0, 180) || "El servidor no ha respost.");
  }
  return JSON.parse(text.slice(inici, fi + 1));
}

function Detallsclient({
  mode,
  client,
  clients,
  onNavigate,
  onSave,
  onCancel,
  onDeleted,
  onCanviarMode,
  onTreballs,
  onPressupostos,
  subnav,
}) {
  const isReadOnly = mode === "consultar" || mode === "esborrar";
  TeclaEscEnter(onCancel, null);

  const { empresaSeleccionada, rolUsuari } = useUserContext();
  const [empresaUsuari] = useState(empresaSeleccionada);
  const pucModificar = tincPermis(rolUsuari, "MODIFICAR");
  const pucEsborrarFitxa = tincPermis(rolUsuari, "ESBORRAR");

  const [tipusEntitat, setTipusEntitat] = useState("");
  const [nom, setNom] = useState("");
  const [cognom1, setCognom1] = useState("");
  const [cognom2, setCognom2] = useState("");
  const [nomComercial, setNomComercial] = useState("");
  const [cifDni, setCifDni] = useState("");
  const [tipusVia, setTipusVia] = useState("");
  const [nomVia, setNomVia] = useState("");
  const [numVia, setNumVia] = useState("");
  const [escalaVia, setEscalaVia] = useState("");
  const [pis, setPis] = useState("");
  const [porta, setPorta] = useState("");
  const [poblacio, setPoblacio] = useState("");
  const [provincia, setProvincia] = useState("");
  const [pais, setPais] = useState("");
  const [codiPostal, setCodiPostal] = useState("");
  const [referencies, setReferencies] = useState("");
  const [telefon, setTelefon] = useState("");
  const [mobil1, setMobil1] = useState("");
  const [mobil2, setMobil2] = useState("");
  const [whatsapp, setWhatsapp] = useState("");
  const [paginaWeb, setPaginaWeb] = useState("");
  const [email1, setEmail1] = useState("");
  const [email2, setEmail2] = useState("");
  const [compteBancari, setCompteBancari] = useState("");
  const [actiu, setActiu] = useState(true);
  const [professio, setProfessio] = useState(null);
  const [professioDescripcio, setProfessioDescripcio] = useState("");
  const [tipusClient, setTipusClient] = useState(null);
  const [tipusClientDescripcio, setTipusClientDescripcio] = useState("");
  const [diesPagament, setDiesPagament] = useState(60);
  const [diaPagament, setDiaPagament] = useState(30);
  const [dePartDeNom, setDePartDeNom] = useState("");
  const [idDePartDe, setIdDePartDe] = useState(null);

  const [tipusClientOptions, setTipusClientOptions] = useState([]);
  const [professionsOptions, setProfessionsOptions] = useState([]);
  const [optionsDePartDe, setOptionsDePartDe] = useState([]);
  const [showDropdownDePartDe, setShowDropdownDePartDe] = useState(false);

  const [catalogModal, setCatalogModal] = useState(null);
  const [catalogNom, setCatalogNom] = useState("");
  const [catalogBusy, setCatalogBusy] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [desant, setDesant] = useState(false);
  const [menuAccions, setMenuAccions] = useState(false);
  const [mostraAjuda, setMostraAjuda] = useState(false);

  const [contactes, setContactes] = useState([]);
  const [filtreContacte, setFiltreContacte] = useState("");
  const [contacteSeleccionat, setContacteSeleccionat] = useState(null);

  const fetchTipusClient = async () => {
    try {
      const response = await fetch(`${API_URL}/Tipusclient.php`);
      const data = await response.json();
      if (data.success) setTipusClientOptions(data.data || []);
    } catch (e) {
      console.error("Error TipusClient:", e);
    }
  };

  const fetchTipusProfessions = async () => {
    try {
      const response = await fetch(`${API_URL}/Tipusprofessions.php`);
      const data = await response.json();
      if (data.success) setProfessionsOptions(data.data || []);
    } catch (e) {
      console.error("Error Professions:", e);
    }
  };

  useEffect(() => {
    fetchTipusClient();
    fetchTipusProfessions();
  }, []);

  useEffect(() => {
    if (mode === "nou" && empresaUsuari?.IdEmpresa) {
      const fetchContactes = async () => {
        try {
          const response = await fetch(`${API_URL}/Contactes.php`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ idEmpresa: empresaUsuari.IdEmpresa }),
          });
          const data = await response.json();
          if (data.success && Array.isArray(data.contactes)) {
            setContactes(data.contactes);
          }
        } catch (e) {
          console.error("Error carregant contactes:", e);
        }
      };
      fetchContactes();
    }
  }, [mode, empresaUsuari]);

  useEffect(() => {
    if (!empresaUsuari?.IdEmpresa) return;
    const fetchEntitats = async () => {
      try {
        const response = await fetch(`${API_URL}/Entitatsempresa.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ idEmpresa: empresaUsuari.IdEmpresa }),
        });
        const result = await response.json();
        if (result.success) setOptionsDePartDe(result.entitats || []);
      } catch (e) {
        console.error("Error entitats:", e);
      }
    };
    fetchEntitats();
  }, [empresaUsuari]);

  const resetForm = useCallback(() => {
    setTipusEntitat("Empresa");
    setNom("");
    setCognom1("");
    setCognom2("");
    setNomComercial("");
    setCifDni("");
    setTipusVia("");
    setNomVia("");
    setNumVia("");
    setEscalaVia("");
    setPis("");
    setPorta("");
    setPoblacio("");
    setProvincia("");
    setPais("");
    setCodiPostal("");
    setReferencies("");
    setTelefon("");
    setMobil1("");
    setMobil2("");
    setWhatsapp("");
    setPaginaWeb("");
    setEmail1("");
    setEmail2("");
    setCompteBancari("");
    setActiu(true);
    setProfessio(null);
    setProfessioDescripcio("");
    setTipusClient(null);
    setTipusClientDescripcio("");
    setDiesPagament(60);
    setDiaPagament(30);
    setDePartDeNom(empresaUsuari?.Nom || "");
    setIdDePartDe(empresaUsuari?.Entitats_idEntitats || null);
    setContacteSeleccionat(null);
    setFiltreContacte("");
  }, [empresaUsuari]);

  useEffect(() => {
    if (client) {
      setTipusEntitat(client.TipusEntitat || "Empresa");
      setNom(client.Nom || "");
      setCognom1(client.Cognom1 || "");
      setCognom2(client.Cognom2 || "");
      setNomComercial(client.NomComercial || "");
      setCifDni(client.CIF_DNI || "");
      setTipusVia(client.TipusVia || "");
      setNomVia(client.NomVia || "");
      setNumVia(client.NumVia || "");
      setEscalaVia(client.EscalaVia || "");
      setPis(client.Pis || "");
      setPorta(client.Porta || "");
      setPoblacio(client.Poblacio || "");
      setProvincia(client.Provincia || "");
      setPais(client.Pais || "");
      setCodiPostal(client.CodiPostal || "");
      setReferencies(client.Referencies || "");
      setTelefon(client.TelefonFixe || "");
      setMobil1(client.TelefonMobil || "");
      setMobil2(client.TelefonMobil2 || "");
      setWhatsapp(client.Whatsapp || "");
      setPaginaWeb(client.PaginaWeb || "");
      setEmail1(client.Email1 || "");
      setEmail2(client.Email2 || "");
      setCompteBancari(client.CompteBancari || "");
      setActiu(client.Activitat ?? true);
      setProfessio(client.Professions_idProfessions || null);
      setTipusClient(client.TipusClient || null);
      setTipusClientDescripcio(client.TipusClientDescripcio || "");

      if (mode === "nou") {
        setDiesPagament(60);
        setDiaPagament(30);
        setDePartDeNom(empresaUsuari?.Nom || "");
        setIdDePartDe(empresaUsuari?.Entitats_idEntitats || null);
      } else if (["consultar", "modificar", "esborrar"].includes(mode)) {
        setDiesPagament(client.DiesPagament ?? null);
        setDiaPagament(client.DiaPagament ?? null);
        setDePartDeNom(client.DePartDeNom || "");
        setIdDePartDe(client.IdDePartDe || null);
      }
    } else {
      resetForm();
    }
  }, [client, mode, empresaUsuari, resetForm]);

  useEffect(() => {
    if (client?.Professions_idProfessions && professionsOptions.length > 0) {
      const op = professionsOptions.find((o) => mateixId(o.idProfessions, client.Professions_idProfessions));
      setProfessioDescripcio(op?.Descripcio || "");
    }
  }, [client?.Professions_idProfessions, professionsOptions]);

  const handleSeleccionarContacte = useCallback(
    (idContacte) => {
      if (!idContacte) {
        setContacteSeleccionat(null);
        return;
      }
      const contacte = contactes.find((c) => mateixId(c.idContactes, idContacte));
      if (!contacte) return;
      setContacteSeleccionat(contacte);
      setNom(contacte.Nom || "");
      setCognom1(contacte.Cognom1 || "");
      setCognom2(contacte.Cognom2 || "");
      setTelefon(contacte.Telefon || "");
      setEmail1(contacte.Email || "");
      setWhatsapp(contacte.Whatsapp || "");
      setTipusVia(contacte.TipusVia || "");
      setNomVia(contacte.NomVia || "");
      setNumVia(contacte.NumVia || "");
      setEscalaVia(contacte.EscalaVia || "");
      setPis(contacte.Pis || "");
      setPorta(contacte.Porta || "");
      setPoblacio(contacte.Poblacio || "");
      setProvincia(contacte.Provincia || "");
      setPais(contacte.Pais || "");
      setCodiPostal(contacte.CodiPostal || "");
      setReferencies(contacte.Referencies || "");
      if (contacte.Cognom1 || contacte.Cognom2) setTipusEntitat("Particular");
    },
    [contactes]
  );

  const contactesFiltrats = React.useMemo(() => {
    if (!filtreContacte.trim()) return contactes;
    const filtre = filtreContacte.toLowerCase();
    return contactes.filter((c) =>
      [c.Nom, c.Cognom1, c.Cognom2, c.Telefon, c.Email].filter(Boolean).join(" ").toLowerCase().includes(filtre)
    );
  }, [contactes, filtreContacte]);

  const currentIndex = clients ? clients.findIndex((c) => mateixId(c.idClients, client?.idClients)) : -1;

  const anteriorClient = () => {
    if (!clients || clients.length === 0 || currentIndex < 0) return;
    const newIndex = currentIndex === 0 ? clients.length - 1 : currentIndex - 1;
    onNavigate?.(clients[newIndex]);
  };

  const seguentClient = () => {
    if (!clients || clients.length === 0 || currentIndex < 0) return;
    const newIndex = currentIndex === clients.length - 1 ? 0 : currentIndex + 1;
    onNavigate?.(clients[newIndex]);
  };

  const validacioClient = (clientData) => {
    const { Entitats, Adreces, Clients: dadesClient } = clientData;
    const errors = [];
    const avisos = [];
    const esPersona = ["Particular", "Autonom"].includes(Entitats.TipusEntitat);
    const etiquetaDoc = esPersona ? "NIF" : "CIF";

    if (!Entitats.TipusEntitat) errors.push("L'organització és obligatòria.");
    if (!Entitats.Nom?.trim()) errors.push("El camp Nom és obligatori.");
    if (esPersona && !Entitats.Cognom1?.trim()) {
      errors.push("El 1r Cognom és obligatori per Particulars o Autònoms.");
    }
    if (!Adreces.TipusVia?.trim()) errors.push("El Tipus de Via és obligatori.");
    if (!Adreces.NomVia?.trim()) errors.push("El Nom de la Via és obligatori.");
    if (!Adreces.NumVia?.trim()) errors.push("El Número de la Via és obligatori.");
    if (!Adreces.Poblacio?.trim()) errors.push("El camp Població és obligatori.");
    if (!Adreces.Provincia?.trim()) errors.push("El camp Província és obligatori.");
    if (!Adreces.Pais?.trim()) errors.push("El camp País és obligatori.");
    if (!Adreces.CodiPostal?.trim()) errors.push("El camp Codi Postal és obligatori.");
    if (!dadesClient.TipusClient) {
      errors.push("El Tipus de Client és obligatori.");
    } else if (!tipusClientOptions.some((o) => mateixId(o.idTipusClient, dadesClient.TipusClient))) {
      errors.push("El Tipus de Client seleccionat no existeix.");
    }
    if (
      Entitats.Professions_idProfessions &&
      !professionsOptions.some((o) => mateixId(o.idProfessions, Entitats.Professions_idProfessions))
    ) {
      errors.push("La Professió seleccionada no existeix.");
    }

    aplicarValidacio(errors, avisos, "Telèfon fixe", validarTelefon(Entitats.Telefon));
    aplicarValidacio(errors, avisos, "Mòbil 1", validarTelefon(Entitats.TelefonMobil));
    aplicarValidacio(errors, avisos, "Whatsapp", validarTelefon(Entitats.Whatsapp));
    aplicarValidacio(errors, avisos, "Mòbil 2", validarTelefon(Entitats.TelefonMobil2));
    aplicarValidacio(errors, avisos, "E-mail 1", validarEmail(Entitats.Email1));
    aplicarValidacio(errors, avisos, "E-mail 2", validarEmail(Entitats.Email2));
    aplicarValidacio(errors, avisos, "Pàgina web", validarUrl(Entitats.PaginaWeb));
    aplicarValidacio(errors, avisos, "Codi postal", validarCodiPostal(Adreces.CodiPostal));
    aplicarValidacio(errors, avisos, etiquetaDoc, validarDocumentIdentitat(Entitats.CIF_DNI));

    if (dadesClient.DiaPagament != null && (dadesClient.DiaPagament < 1 || dadesClient.DiaPagament > 31)) {
      errors.push("El dia del mes ha de ser entre 1 i 31.");
    }
    if (dadesClient.DiesPagament != null && dadesClient.DiesPagament < 0) {
      errors.push("Els dies de pagament no poden ser negatius.");
    }

    return { errors, avisos };
  };

  const clientModificat = (clientOriginal, clientData) => {
    const updated = {
      ...clientOriginal,
      TipusEntitat: clientData.Entitats.TipusEntitat,
      Nom: clientData.Entitats.Nom,
      Cognom1: clientData.Entitats.Cognom1,
      Cognom2: clientData.Entitats.Cognom2,
      NomComercial: clientData.Entitats.NomComercial,
      CIF_DNI: clientData.Entitats.CIF_DNI,
      TelefonFixe: clientData.Entitats.Telefon,
      TelefonMobil: clientData.Entitats.TelefonMobil,
      TelefonMobil2: clientData.Entitats.TelefonMobil2,
      Whatsapp: clientData.Entitats.Whatsapp,
      PaginaWeb: clientData.Entitats.PaginaWeb,
      Email1: clientData.Entitats.Email1,
      Email2: clientData.Entitats.Email2,
      CompteBancari: clientData.Entitats.CompteBancari,
      Activitat: clientData.Entitats.Activitat,
      Professions_idProfessions: clientData.Entitats.Professions_idProfessions,
      TipusVia: clientData.Adreces.TipusVia,
      NomVia: clientData.Adreces.NomVia,
      NumVia: clientData.Adreces.NumVia,
      EscalaVia: clientData.Adreces.EscalaVia,
      Pis: clientData.Adreces.Pis,
      Porta: clientData.Adreces.Porta,
      Poblacio: clientData.Adreces.Poblacio,
      Provincia: clientData.Adreces.Provincia,
      Pais: clientData.Adreces.Pais,
      CodiPostal: clientData.Adreces.CodiPostal,
      Referencies: clientData.Adreces.Referencies,
      TipusClient: clientData.Clients.TipusClient,
      DiesPagament: clientData.Clients.DiesPagament,
      DiaPagament: clientData.Clients.DiaPagament,
      DePartDeNom: clientData.Clients.DePartDeNom,
      IdDePartDe: clientData.Clients.IdDePartDe,
    };
    updated.TipusClientDescripcio =
      tipusClientOptions.find((o) => mateixId(o.idTipusClient, updated.TipusClient))?.Descripcio ||
      clientOriginal.TipusClientDescripcio;
    if (updated.Professions_idProfessions) {
      updated.ProfessioDescripcio =
        professionsOptions.find((o) => mateixId(o.idProfessions, updated.Professions_idProfessions))?.Descripcio ||
        clientOriginal.ProfessioDescripcio;
    }
    return updated;
  };

  const handleSubmit = async () => {
    if (desant) return;
    const clientData = {
      idClients: client?.idClients || null,
      Entitats: {
        IdEntitats: client?.Entitats_idEntitats || null,
        TipusEntitat: tipusEntitat,
        Nom: nom,
        Cognom1: cognom1,
        Cognom2: cognom2,
        NomComercial: nomComercial,
        CIF_DNI: cifDni,
        Telefon: telefon,
        TelefonMobil: mobil1,
        TelefonMobil2: mobil2,
        Whatsapp: whatsapp,
        PaginaWeb: paginaWeb,
        Email1: email1,
        Email2: email2,
        CompteBancari: compteBancari || null,
        Activitat: actiu,
        Professions_idProfessions: professio,
      },
      Adreces: {
        TipusVia: tipusVia,
        NomVia: nomVia,
        NumVia: numVia,
        EscalaVia: escalaVia,
        Pis: pis,
        Porta: porta,
        Poblacio: poblacio,
        Provincia: provincia,
        Pais: pais,
        CodiPostal: codiPostal,
        Referencies: referencies,
      },
      Clients: {
        TipusClient: tipusClient,
        DiesPagament: diesPagament,
        DiaPagament: diaPagament,
        DePartDeNom: dePartDeNom,
        IdDePartDe: idDePartDe,
      },
      Empresa_Clients: {
        Empresa_IdEmpresa: empresaUsuari?.IdEmpresa || null,
      },
    };

    if (mode === "nou" && contacteSeleccionat?.idContactes) {
      clientData.idContacteOrigen = contacteSeleccionat.idContactes;
    }

    const { errors, avisos } = validacioClient(clientData);
    if (errors.length > 0) {
      alert(`Errors trobats:\n${errors.join("\n")}`);
      return;
    }
    if (avisos.length > 0) {
      const continua = window.confirm(`${avisos.join("\n")}\n\nSón només avisos. Vols desar igualment?`);
      if (!continua) return;
    }

    if (mode === "esborrar") {
      setShowDeleteModal(true);
      return;
    }

    setDesant(true);
    try {
      if (mode === "nou") {
        const response = await fetch(`${API_URL}/Nouclient.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(clientData),
        });
        const data = await llegirResposta(response);
        if (data.success) {
          alert("Client creat correctament!");
          const id = data.idClients ?? data.idClient ?? null;
          onSave?.(id ? { idClients: Number(id) } : null);
        } else {
          alert(`Error en crear el client: ${data.message}`);
        }
      } else if (mode === "modificar") {
        clientData.idClients = client.idClients;
        const response = await fetch(`${API_URL}/Modificarclient.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(clientData),
        });
        const data = await llegirResposta(response);
        if (data.success) {
          alert("Client modificat correctament!");
          onSave?.(clientModificat(client, clientData));
        } else {
          alert(`Error en modificar el client: ${data.message}`);
        }
      }
    } catch (error) {
      console.error("Error en l'operació del client:", error);
      alert(`S'ha produït un error en el procés. ${error?.message || ""}`.trim());
    } finally {
      setDesant(false);
    }
  };

  const confirmarEsborrat = async () => {
    try {
      const response = await fetch(`${API_URL}/Esborrarclient.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idClient: client.idClients,
          idEmpresa: empresaUsuari?.IdEmpresa || null,
        }),
      });
      const data = await llegirResposta(response);
      if (data.success) {
        alert("Client esborrat correctament!");
        setShowDeleteModal(false);
        onDeleted?.();
      } else {
        alert(data.message || "No s'ha pogut esborrar el client.");
        setShowDeleteModal(false);
      }
    } catch (error) {
      console.error("Error en esborrar el client:", error);
      alert("S'ha produït un error.");
      setShowDeleteModal(false);
    }
  };

  const obrirCatalog = (kind, action) => {
    if (action === "modif") {
      if (kind === "professions" && !professio) {
        alert("Selecciona primer una professió per modificar-la.");
        return;
      }
      if (kind === "tipusclient" && !tipusClient) {
        alert("Selecciona primer un tipus de client per modificar-lo.");
        return;
      }
    }
    const nomActual =
      kind === "professions"
        ? professioDescripcio
        : tipusClientDescripcio;
    setCatalogModal({ kind, action });
    setCatalogNom(action === "modif" ? nomActual || "" : "");
  };

  const desarCatalog = async () => {
    const nomNou = (catalogNom || "").trim();
    if (!nomNou) {
      alert("La descripció no pot estar buida.");
      return;
    }
    if (!catalogModal) return;
    setCatalogBusy(true);
    try {
      if (catalogModal.action === "modif") {
        const id = catalogModal.kind === "professions" ? professio : tipusClient;
        const response = await fetch(`${API_URL}/Modifica${catalogModal.kind}.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id, newDescription: nomNou }),
        });
        const data = await response.json();
        if (!data.success) {
          alert(data.message || "No s'ha pogut modificar.");
          return;
        }
        if (catalogModal.kind === "professions") {
          await fetchTipusProfessions();
          setProfessioDescripcio(nomNou);
        } else {
          await fetchTipusClient();
          setTipusClientDescripcio(nomNou);
        }
      } else {
        const response = await fetch(`${API_URL}/Alta${catalogModal.kind}.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ description: nomNou }),
        });
        const data = await response.json();
        if (!data.success) {
          alert(data.message || "No s'ha pogut crear.");
          return;
        }
        const nouId = data.id != null ? Number(data.id) : null;
        if (catalogModal.kind === "professions") {
          await fetchTipusProfessions();
          if (nouId) setProfessio(nouId);
          setProfessioDescripcio(nomNou);
        } else {
          await fetchTipusClient();
          if (nouId) setTipusClient(nouId);
          setTipusClientDescripcio(nomNou);
        }
      }
      setCatalogModal(null);
      setCatalogNom("");
    } catch (error) {
      console.error("Error al catàleg:", error);
      alert("Hi ha hagut un error. Torna-ho a intentar.");
    } finally {
      setCatalogBusy(false);
    }
  };

  const tipusLabel = mapToPresentable(tipusEntitat, mapejos.tipusEntitat);
  const nomComplet = [
    [cognom1, cognom2].filter((x) => x && String(x).trim()).join(" "),
    nom,
  ]
    .filter((x) => x && String(x).trim())
    .join(", ");
  const adreca = {
    TipusVia: tipusVia,
    NomVia: nomVia,
    NumVia: numVia,
    EscalaVia: escalaVia,
    Pis: pis,
    Porta: porta,
    Poblacio: poblacio,
  };
  const teCognoms = ["Particular", "Autonom"].includes(tipusEntitat);
  const teNomComercial = ["Empresa", "Autonom"].includes(tipusEntitat);
  const idLabel = teCognoms ? "NIF" : "CIF";
  const potNavegar = ["consultar", "modificar"].includes(mode) && clients && clients.length > 1 && currentIndex >= 0;
  const textDePartDe = (dePartDeNom || "").trim().toLowerCase();
  const seleccioExacta = (optionsDePartDe || []).some(
    (opt) => mateixId(idDePartDe, opt.idEntitats) && etiquetaDePartDe(opt).toLowerCase() === textDePartDe
  );
  const esEmpresaPerDefecte =
    textDePartDe !== "" &&
    textDePartDe === String(empresaUsuari?.Nom || "").trim().toLowerCase() &&
    mateixId(idDePartDe, empresaUsuari?.Entitats_idEntitats);
  const mostraTotesDePartDe = textDePartDe === "" || seleccioExacta || esEmpresaPerDefecte;
  const optionsDePartDeFiltrades = mostraTotesDePartDe
    ? optionsDePartDe || []
    : (optionsDePartDe || []).filter((opt) => etiquetaDePartDe(opt).toLowerCase().includes(textDePartDe));

  const titolFitxa =
    mode === "nou"
      ? "Nou client"
      : mode === "esborrar"
      ? "Esborrar client"
      : mode === "modificar"
      ? "Modificar client"
      : "Clients · Fitxa";

  const camp = (label, required, content, mida = "mig") => {
    const extra =
      mida === true || mida === "wide" || mida === "ample"
        ? "dv2-field--ample"
        : mida === "long" || mida === "llarg"
        ? "dv2-field--llarg"
        : mida === "curt"
        ? "dv2-field--curt"
        : "dv2-field--mig";
    return (
      <label className={`dv2-field ${extra}`}>
        <span className={`dv2-label ${required && !isReadOnly ? "dv2-required" : ""}`}>{label}</span>
        {content}
      </label>
    );
  };

  const renderCatalogSelect = (kind) => {
    const esProf = kind === "professions";
    const valor = esProf ? professio : tipusClient;
    const opcions = esProf ? professionsOptions : tipusClientOptions;
    const idKey = esProf ? "idProfessions" : "idTipusClient";
    const texte = esProf ? professioDescripcio : tipusClientDescripcio;
    if (isReadOnly) {
      return <span className="dv2-value">{texte || "—"}</span>;
    }
    return (
      <div className="dv2-controlRow">
        <select
          className="dv2-select"
          value={valor != null ? String(valor) : ""}
          onChange={(e) => {
            const id = e.target.value ? Number(e.target.value) : null;
            const op = opcions.find((o) => mateixId(o[idKey], id));
            if (esProf) {
              setProfessio(id);
              setProfessioDescripcio(op?.Descripcio || "");
            } else {
              setTipusClient(id);
              setTipusClientDescripcio(op?.Descripcio || "");
            }
          }}
        >
          <option value="">{esProf ? "— Sense professió —" : "Selecciona"}</option>
          {opcions.map((o) => (
            <option key={o[idKey]} value={String(o[idKey])}>
              {o.Descripcio}
            </option>
          ))}
        </select>
        <button type="button" className="dv2-btn dv2-btn--compact" onClick={() => obrirCatalog(kind, "alta")}>
          {esProf ? "+ Nova" : "+ Nou"}
        </button>
        {valor ? (
          <button type="button" className="dv2-btn dv2-btn--ghost dv2-btn--compact" onClick={() => obrirCatalog(kind, "modif")}>
            Canvia nom
          </button>
        ) : null}
      </div>
    );
  };

  const renderCamps = () => (
    <>
      {mode === "nou" && (
        <section className="dv2-card">
          <div className="dv2-card-head">
            <span className="dv2-card-num">0</span>
            <h2 className="dv2-card-title">Partir d'un contacte</h2>
          </div>
          <div className="dv2-fields dv2-fields--sizes">
            {camp(
              "Cerca",
              false,
              <input
                type="text"
                className="dv2-input"
                placeholder="Nom, email, telèfon…"
                value={filtreContacte}
                onChange={(e) => setFiltreContacte(e.target.value)}
              />
            )}
            {camp(
              "Contacte",
              false,
              <select
                className="dv2-select"
                value={contacteSeleccionat?.idContactes || ""}
                onChange={(e) => handleSeleccionarContacte(e.target.value)}
              >
                <option value="">— Crear des de zero —</option>
                {contactesFiltrats.map((c) => {
                  const cognoms = [c.Cognom1, c.Cognom2].filter(Boolean).join(" ");
                  const nomOpt = [cognoms, c.Nom].filter(Boolean).join(", ");
                  const extra = [c.Telefon, c.Email].filter(Boolean).join(" | ");
                  return (
                    <option key={c.idContactes} value={c.idContactes}>
                      {nomOpt} {extra ? `(${extra})` : ""}
                    </option>
                  );
                })}
              </select>,
              "llarg"
            )}
          </div>
        </section>
      )}

      <section className="dv2-card">
        <div className="dv2-card-head">
          <span className="dv2-card-num">1</span>
          <h2 className="dv2-card-title">Identificació</h2>
        </div>
        <div className="dv2-fields dv2-fields--sizes">
          {camp(
            "Organització",
            true,
            isReadOnly ? (
              <span className="dv2-value">{tipusLabel || "—"}</span>
            ) : (
              <select className="dv2-select" value={tipusEntitat} onChange={(e) => setTipusEntitat(e.target.value)}>
                <option value="">Selecciona</option>
                {Object.keys(mapejos.tipusEntitat).map((option) => (
                  <option key={option} value={option}>
                    {mapToPresentable(option, mapejos.tipusEntitat)}
                  </option>
                ))}
              </select>
            ),
            "curt"
          )}
          {camp(
            "Nom",
            true,
            isReadOnly ? (
              <span className="dv2-value">{nom || "—"}</span>
            ) : (
              <input type="text" className="dv2-input" value={nom} maxLength={100} onChange={(e) => setNom(e.target.value)} />
            ),
            "llarg"
          )}
          {teCognoms &&
            camp(
              "1r cognom",
              true,
              isReadOnly ? (
                <span className="dv2-value">{cognom1 || "—"}</span>
              ) : (
                <input type="text" className="dv2-input" value={cognom1} onChange={(e) => setCognom1(e.target.value)} />
              )
            )}
          {teCognoms &&
            camp(
              "2n cognom",
              false,
              isReadOnly ? (
                <span className="dv2-value">{cognom2 || "—"}</span>
              ) : (
                <input type="text" className="dv2-input" value={cognom2} onChange={(e) => setCognom2(e.target.value)} />
              )
            )}
          {teNomComercial &&
            camp(
              "Nom comercial",
              false,
              isReadOnly ? (
                <span className="dv2-value">{nomComercial || "—"}</span>
              ) : (
                <input
                  type="text"
                  className="dv2-input"
                  value={nomComercial}
                  maxLength={100}
                  onChange={(e) => setNomComercial(e.target.value)}
                />
              ),
              "llarg"
            )}
          {camp(
            idLabel,
            false,
            isReadOnly ? (
              <span className="dv2-value">{cifDni || "—"}</span>
            ) : (
              <input type="text" className="dv2-input" value={cifDni} maxLength={12} onChange={(e) => setCifDni(e.target.value)} />
            )
          )}
        </div>
      </section>

      <section className="dv2-card">
        <div className="dv2-card-head">
          <span className="dv2-card-num">2</span>
          <h2 className="dv2-card-title">Adreça</h2>
        </div>
        {isReadOnly ? (
          <div className="dv2-fields dv2-fields--sizes">
            {camp("Adreça", false, <span className="dv2-value">{formatAddress(adreca) || "—"}</span>, "ample")}
            {camp("Referències", false, <span className="dv2-value">{referencies || "Sense referències."}</span>, "ample")}
          </div>
        ) : (
          <div className="dv2-fields dv2-fields--sizes">
            {camp(
              "Tipus de via",
              true,
              <select className="dv2-select" value={tipusVia} onChange={(e) => setTipusVia(e.target.value)}>
                <option value="">Selecciona</option>
                {Object.keys(mapejos.tipusVia).map((option) => (
                  <option key={option} value={option}>
                    {mapToPresentable(option, mapejos.tipusVia)}
                  </option>
                ))}
              </select>
            )}
            {camp(
              "Nom de la via",
              true,
              <input type="text" className="dv2-input" value={nomVia} maxLength={100} onChange={(e) => setNomVia(e.target.value)} />,
              "llarg"
            )}
            {camp(
              "Número",
              true,
              <input type="text" className="dv2-input" value={numVia} maxLength={15} onChange={(e) => setNumVia(e.target.value)} />,
              "curt"
            )}
            {camp(
              "Escala",
              false,
              <input type="text" className="dv2-input" value={escalaVia} maxLength={10} onChange={(e) => setEscalaVia(e.target.value)} />,
              "curt"
            )}
            {camp(
              "Pis",
              false,
              <input type="text" className="dv2-input" value={pis} maxLength={25} onChange={(e) => setPis(e.target.value)} />,
              "curt"
            )}
            {camp(
              "Porta",
              false,
              <input type="text" className="dv2-input" value={porta} maxLength={5} onChange={(e) => setPorta(e.target.value)} />,
              "curt"
            )}
            {camp(
              "Població",
              true,
              <input type="text" className="dv2-input" value={poblacio} maxLength={100} onChange={(e) => setPoblacio(e.target.value)} />
            )}
            {camp(
              "Província",
              true,
              <input type="text" className="dv2-input" value={provincia} maxLength={50} onChange={(e) => setProvincia(e.target.value)} />
            )}
            {camp(
              "País",
              true,
              <input type="text" className="dv2-input" value={pais} maxLength={100} onChange={(e) => setPais(e.target.value)} />
            )}
            {camp(
              "Codi postal",
              true,
              <input type="text" className="dv2-input" value={codiPostal} maxLength={10} onChange={(e) => setCodiPostal(e.target.value)} />,
              "curt"
            )}
            {camp(
              "Referències",
              false,
              <textarea className="dv2-textarea" value={referencies} maxLength={256} onChange={(e) => setReferencies(e.target.value)} />,
              "ample"
            )}
          </div>
        )}
      </section>

      <section className="dv2-card">
        <div className="dv2-card-head">
          <span className="dv2-card-num">3</span>
          <h2 className="dv2-card-title">Contacte</h2>
        </div>
        <div className="dv2-fields dv2-fields--sizes">
          {camp(
            "Telèfon fixe",
            false,
            isReadOnly ? (
              <span className="dv2-value">{telefon || "—"}</span>
            ) : (
              <input type="text" className="dv2-input" value={telefon} maxLength={20} onChange={(e) => setTelefon(e.target.value)} />
            )
          )}
          {camp(
            "Mòbil 1",
            false,
            isReadOnly ? (
              <span className="dv2-value">{mobil1 || "—"}</span>
            ) : (
              <input type="text" className="dv2-input" value={mobil1} maxLength={20} onChange={(e) => setMobil1(e.target.value)} />
            )
          )}
          {camp(
            "Whatsapp",
            false,
            isReadOnly ? (
              <span className="dv2-value">{whatsapp || "—"}</span>
            ) : (
              <input type="text" className="dv2-input" value={whatsapp} maxLength={20} onChange={(e) => setWhatsapp(e.target.value)} />
            )
          )}
          {camp(
            "Mòbil 2",
            false,
            isReadOnly ? (
              <span className="dv2-value">{mobil2 || "—"}</span>
            ) : (
              <input type="text" className="dv2-input" value={mobil2} maxLength={20} onChange={(e) => setMobil2(e.target.value)} />
            )
          )}
          {camp(
            "E-mail 1",
            false,
            isReadOnly ? (
              <span className="dv2-value">{email1 || "—"}</span>
            ) : (
              <input type="email" className="dv2-input" value={email1} maxLength={45} onChange={(e) => setEmail1(e.target.value)} />
            ),
            "llarg"
          )}
          {camp(
            "E-mail 2",
            false,
            isReadOnly ? (
              <span className="dv2-value">{email2 || "—"}</span>
            ) : (
              <input type="email" className="dv2-input" value={email2} maxLength={45} onChange={(e) => setEmail2(e.target.value)} />
            ),
            "llarg"
          )}
          {camp(
            "Pàgina web",
            false,
            isReadOnly ? (
              <span className="dv2-value">{paginaWeb || "—"}</span>
            ) : (
              <input type="text" className="dv2-input" value={paginaWeb} maxLength={100} onChange={(e) => setPaginaWeb(e.target.value)} />
            ),
            "llarg"
          )}
        </div>
      </section>

      <section className="dv2-card">
        <div className="dv2-card-head">
          <span className="dv2-card-num">4</span>
          <h2 className="dv2-card-title">Comercial</h2>
        </div>
        <div className="dv2-fields dv2-fields--sizes">
          {camp("Tipus de client", true, renderCatalogSelect("tipusclient"), "llarg")}
          {camp("Professió", false, renderCatalogSelect("professions"), "llarg")}
          {camp(
            "Actiu",
            false,
            isReadOnly ? (
              <span className="dv2-value">{actiu ? "Sí" : "No"}</span>
            ) : (
              <span className="dv2-toggleRow">
                <span className="dv2-toggle">
                  <input type="checkbox" checked={!!actiu} onChange={(e) => setActiu(e.target.checked)} />
                  <span className="dv2-toggle-track" />
                </span>
              </span>
            ),
            "curt"
          )}
          {camp(
            "De part de",
            false,
            isReadOnly ? (
              <span className="dv2-value">{dePartDeNom || "—"}</span>
            ) : (
              <div className="dv2-combo">
                <input
                  type="text"
                  className="dv2-input"
                  maxLength={256}
                  value={dePartDeNom || ""}
                  placeholder="Selecciona o escriu un nom"
                  onFocus={() => setShowDropdownDePartDe(true)}
                  onBlur={() => setTimeout(() => setShowDropdownDePartDe(false), 200)}
                  onChange={(e) => {
                    const inputValue = e.target.value;
                    setDePartDeNom(inputValue);
                    const matched = optionsDePartDe.find(
                      (opt) => etiquetaDePartDe(opt).toLowerCase() === inputValue.trim().toLowerCase()
                    );
                    setIdDePartDe(matched ? matched.idEntitats ?? null : null);
                  }}
                />
                {showDropdownDePartDe && (
                  <div className="dv2-combo-list">
                    {optionsDePartDeFiltrades.length === 0 ? (
                      <div className="dv2-combo-option">
                        {(optionsDePartDe || []).length === 0 ? "No hi ha ningú per triar." : "Cap coincidència."}
                      </div>
                    ) : (
                      optionsDePartDeFiltrades.map((opt, idx) => (
                        <div
                          key={opt.idEntitats ?? `contact-${idx}`}
                          className={`dv2-combo-option ${mateixId(idDePartDe, opt.idEntitats) ? "is-active" : ""}`}
                          onMouseDown={() => {
                            setDePartDeNom(etiquetaDePartDe(opt));
                            setIdDePartDe(opt.idEntitats ?? null);
                            setShowDropdownDePartDe(false);
                          }}
                        >
                          {etiquetaDePartDe(opt)}
                          {opt.Papers ? ` · ${opt.Papers}` : ""}
                        </div>
                      ))
                    )}
                  </div>
                )}
              </div>
            )
          )}
          {camp(
            "A pagar (dies)",
            false,
            isReadOnly ? (
              <span className="dv2-value">{diesPagament ?? "—"}</span>
            ) : (
              <input
                type="number"
                className="dv2-input"
                value={diesPagament ?? ""}
                onChange={(e) => setDiesPagament(e.target.value !== "" ? parseInt(e.target.value, 10) : null)}
              />
            ),
            "curt"
          )}
          {camp(
            "Dia del mes",
            false,
            isReadOnly ? (
              <span className="dv2-value">{diaPagament ?? "—"}</span>
            ) : (
              <input
                type="number"
                className="dv2-input"
                value={diaPagament ?? ""}
                onChange={(e) => setDiaPagament(e.target.value !== "" ? parseInt(e.target.value, 10) : null)}
              />
            ),
            "curt"
          )}
        </div>
      </section>
    </>
  );

  const catalogTitol =
    catalogModal?.kind === "professions"
      ? catalogModal.action === "modif"
        ? "Modifica la professió"
        : "Nova professió"
      : catalogModal?.action === "modif"
      ? "Modifica el tipus de client"
      : "Nou tipus de client";

  return (
    <form className="dv2-entity" onSubmit={(e) => e.preventDefault()}>
      {showDeleteModal && (
        <div
          className="dv2-modalOverlay"
          role="dialog"
          aria-modal="true"
          aria-labelledby="esborrar-client-title"
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) setShowDeleteModal(false);
          }}
        >
          <div className="dv2-modal">
            <h3 id="esborrar-client-title" className="dv2-modal-title">
              Confirmar esborrat
            </h3>
            <p className="dv2-modal-lead">Estàs segur que vols esborrar aquest client?</p>
            <div className="dv2-modal-actions">
              <button type="button" className="dv2-btn" onClick={() => setShowDeleteModal(false)}>
                No
              </button>
              <button type="button" className="dv2-btn dv2-btn--danger" onClick={confirmarEsborrat}>
                Sí, esborrar
              </button>
            </div>
          </div>
        </div>
      )}

      {catalogModal && (
        <div
          className="dv2-modalOverlay"
          role="dialog"
          aria-modal="true"
          aria-labelledby="catalog-modal-title"
          onMouseDown={(e) => {
            if (!catalogBusy && e.target === e.currentTarget) setCatalogModal(null);
          }}
        >
          <div className="dv2-modal">
            <h3 id="catalog-modal-title" className="dv2-modal-title">
              {catalogTitol}
            </h3>
            <p className="dv2-modal-lead">
              {catalogModal.action === "modif"
                ? "El nou nom s'aplicarà a tots els registres que el fan servir."
                : "El deixarem seleccionat en aquest client."}
            </p>
            <label className="dv2-field">
              <span className="dv2-label dv2-required">Nom</span>
              <input
                type="text"
                className="dv2-input"
                maxLength={100}
                autoFocus
                disabled={catalogBusy}
                value={catalogNom}
                onChange={(e) => setCatalogNom(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    desarCatalog();
                  }
                }}
                placeholder={catalogModal.kind === "professions" ? "Ex. Electricista" : "Ex. Particular, Administració…"}
              />
            </label>
            <div className="dv2-modal-actions">
              <button
                type="button"
                className="dv2-btn"
                disabled={catalogBusy}
                onClick={() => setCatalogModal(null)}
              >
                Cancel·lar
              </button>
              <button type="button" className="dv2-btn dv2-btn--primary" disabled={catalogBusy} onClick={desarCatalog}>
                {catalogModal.action === "modif" ? "Desar" : "Crear"}
              </button>
            </div>
          </div>
        </div>
      )}

      {mostraAjuda && <AjudaEntitats pestanya="clientFitxa" onTancar={() => setMostraAjuda(false)} />}
      <div className="dv2-pageHeader">
        <div className="dv2-pageHeader-main">
          <div className={`dv2-pageHeader-icon ${mode === "esborrar" ? "is-danger" : ""}`} aria-hidden="true">
            {mode === "esborrar" ? "🗑️" : "👥"}
          </div>
          <div>
            <h1 className="dv2-pageHeader-title">{titolFitxa}</h1>
            <p className="dv2-pageHeader-subtitle">
              {mode === "nou"
                ? "Omple la fitxa. Pots crear professió o tipus de client sense sortir."
                : mode === "esborrar"
                ? "No es podrà esborrar si té treballs associats."
                : nomComplet || "Dades del client"}
            </p>
          </div>
        </div>
        <div className="dv2-pageHeader-actions">
          <BotoAjuda title="Com funciona la fitxa del Client" onClick={() => setMostraAjuda(true)} />
          <button type="button" className="dv2-btn" onClick={onCancel}>
            Tornar
          </button>
          {mode === "consultar" && pucModificar && (
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={() => onCanviarMode?.("modificar")}>
              Modificar
            </button>
          )}
          {mode === "consultar" && (
            <div style={{ position: "relative" }}>
              <button type="button" className="dv2-btn" onClick={() => setMenuAccions((v) => !v)}>
                Més accions
              </button>
              {menuAccions && (
                <div className="dv2-menu" style={{ right: 0, top: "42px" }}>
                  {pucModificar && (
                    <button
                      type="button"
                      className="dv2-menu-item"
                      onClick={() => {
                        setMenuAccions(false);
                        onCanviarMode?.("contactes");
                      }}
                    >
                      Contactes
                    </button>
                  )}
                  <button
                    type="button"
                    className="dv2-menu-item"
                    onClick={() => {
                      setMenuAccions(false);
                      onTreballs?.();
                    }}
                  >
                    Treballs
                  </button>
                  <button
                    type="button"
                    className="dv2-menu-item"
                    onClick={() => {
                      setMenuAccions(false);
                      onPressupostos?.();
                    }}
                  >
                    Pressupostos
                  </button>
                  {pucEsborrarFitxa && (
                    <button
                      type="button"
                      className="dv2-menu-item is-danger"
                      onClick={() => {
                        setMenuAccions(false);
                        onCanviarMode?.("esborrar");
                      }}
                    >
                      Esborrar
                    </button>
                  )}
                </div>
              )}
            </div>
          )}
          {(mode === "nou" || mode === "modificar") && (
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit} disabled={desant}>
              {desant ? "Desant…" : "Desar"}
            </button>
          )}
          {mode === "esborrar" && (
            <button type="button" className="dv2-btn dv2-btn--danger" onClick={handleSubmit}>
              Esborrar client
            </button>
          )}
        </div>
      </div>
      {subnav}

      {mode === "esborrar" && (
        <div className="dv2-banner dv2-banner--danger">
          Aquesta acció no es pot desfer. Si el client té treballs associats, el servidor no el deixarà esborrar.
        </div>
      )}

      <div className="dv2-entity-body">{renderCamps()}</div>

      {(potNavegar || mode === "nou" || mode === "modificar" || mode === "esborrar") && (
        <div className="dv2-entity-dock">
          {potNavegar && (
            <div className="dv2-recordNav">
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={anteriorClient} title="Anterior">
                ‹
              </button>
              <span className="dv2-recordNav-info">
                {currentIndex + 1} / {clients.length}
              </span>
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={seguentClient} title="Següent">
                ›
              </button>
            </div>
          )}
          {(mode === "nou" || mode === "modificar" || mode === "esborrar") && (
            <div className="dv2-footerActions">
              <button type="button" className="dv2-btn" onClick={onCancel}>
                Cancel·lar
              </button>
              {mode === "esborrar" ? (
                <button type="button" className="dv2-btn dv2-btn--danger" onClick={handleSubmit}>
                  Esborrar client
                </button>
              ) : (
                <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit} disabled={desant}>
                  {desant ? "Desant…" : mode === "nou" ? "Desar client" : "Desar"}
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </form>
  );
}

export default Detallsclient;
